<template>
    <div v-if="funnel && funnels && funnels.length" class="gs-checkout-navigation">
        <div class="gs-checkout-navigation__selectors">
            <label class="gs-checkout-navigation__field">
                <span>Funnel</span>
                <gs-name-select
                    v-model="localselectedFunnelId"
                    size="full"
                    :options="funnelsWithMainProductsOptions"
                    :placeholder="$t('frontend_resources_index_funnels')"
                    @change="changedFunnel"
                />
            </label>

            <label class="gs-checkout-navigation__field">
                <span>Product</span>
                <gs-name-select
                    v-if="funnelProducts"
                    v-model="localselectedProductId"
                    size="full"
                    :options="funnelProductOptions"
                    :placeholder="$t('frontend_resources_index_funnels')"
                    @change="changedProduct"
                />
            </label>
        </div>
        <div v-if="showCreate" class="gs-checkout-navigation__action">
            <gd-button variant="primary" @click="openCheckoutPagesModal">
                <plus-icon class="w-5 h-5 fill-current" />
                {{ $t('frontend_create') }}
            </gd-button>
        </div>
    </div>
</template>
<script>
import Funnel from '@/models/Funnel';
import PlusIcon from '@/assets/images/icons/PlusIcon.svg';

export default {
    components: {
        PlusIcon,
    },
    props: {
        funnels: {
            type: Array,
            required: true
        },
        funnel: {
            type: Object,
            required: true
        },
        selectedFunnelId: {
            required: true
        },
        selectedProductId: {
            required: true
        },
        openCheckoutPagesModal: {
            type: Function,
            required: true
        },
        showCreate: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            localselectedFunnelId: this.selectedFunnelId,
            localselectedProductId: this.selectedProductId,
        }

    },
    computed: {
        funnelProducts() {
            if (this.funnel && this.funnel.all_products) {
                return this.funnel.all_products.filter((product) => {
                    return product.is_wizard_complete && product.is_complete;
                });
            }
            return [];
        },
        funnelsWithMainProducts() {
            return this.funnels.filter((funnel) => {
                return (
                    funnel.main_product_id > 0 &&
                    funnel.is_live &&
                    funnel.main_product &&
                    funnel.main_product.is_wizard_complete &&
                    funnel.main_product.is_complete
                );
            });
        },
        funnelsWithMainProductsOptions() {
            return this.funnelsWithMainProducts.map((funnel) => {
                return {
                    value: funnel.id,
                    text: funnel.name,
                };
            });
        },
        funnelProductOptions() {
            return this.funnelProducts.map((product) => {
                return {
                    value: product.id,
                    text: product.name,
                };
            });
        },
    },
    methods: {
        async changedFunnel() {
            this.$loader.start('changedFunnel');
            try {
                const selectedFunnel = await Funnel.$find(this.localselectedFunnelId);
                const mainProductId = selectedFunnel.main_product_id;
                await this.$router.push({
                    name: 'productsCheckoutLinks',
                    params: {
                        id: selectedFunnel.id,
                        product_id: mainProductId,
                    },
                });
            } finally {
                this.$loader.end('changedFunnel');
            }
        },
        async changedProduct() {
            this.$loader.start('changedProduct');
            try {
                await this.$router.push({
                    name: 'productsCheckoutLinks',
                    params: {
                        id: this.localselectedFunnelId,
                        product_id: this.localselectedProductId,
                    },
                });
            } finally {
                this.$loader.end('changedProduct');
            }
        },
    }

}
</script>
<style scoped>
.gs-checkout-navigation {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
}

.gs-checkout-navigation__selectors {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 420px));
    gap: 12px;
    width: 100%;
}

.gs-checkout-navigation__field {
    display: grid;
    gap: 6px;
    margin: 0;
}

.gs-checkout-navigation__field > span {
    color: #7c849c;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: .06em;
    text-transform: uppercase;
}

.gs-checkout-navigation__action {
    flex: 0 0 auto;
}

@media (max-width: 780px) {
    .gs-checkout-navigation,
    .gs-checkout-navigation__selectors {
        grid-template-columns: 1fr;
    }

    .gs-checkout-navigation {
        display: grid;
        align-items: stretch;
    }
}
</style>
